export type FreigabeSchluessel = 'webshop';

export const FREIGABE_REGELN: ReadonlyArray<{ pfad: string; schluessel: FreigabeSchluessel }> = [
  { pfad: '/bestellungen/webshop', schluessel: 'webshop' },
  { pfad: '/bestellungen/historie', schluessel: 'webshop' },
  { pfad: '/bestellungen/abo', schluessel: 'webshop' },
];

export function regelFuer(url: string): { pfad: string; schluessel: FreigabeSchluessel } | undefined {
  const pfad = new URL(url, window.location.origin).pathname.toLowerCase();
  return FREIGABE_REGELN.find((r) => pfad === r.pfad.toLowerCase() || pfad.startsWith(r.pfad.toLowerCase() + '/'));
}
